import { render } from "./Index.vue?vue&type=template&id=4c4691a2&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4c4691a2"

export default script